import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const TokoPage = () => (
  <Layout>
    <SEO title="Aplikasi toko" />
    <div class="masthead-followup row m-0">
<div class="col-12 col-md-12 p-3 p-md-5 bg-white text-center">
    <h1><a title="aplikasi toko" href="/toko">Aplikasi toko</a></h1>
    <h2>Aplikasi toko online dan offline untuk all toko usaha dan bisnis</h2>
    <div class="embed-responsive embed-responsive-21by9">
    <iframe title="aplikasi toko online" class="rounded shadow" width="560" height="315" src="https://www.youtube.com/embed/BW6bK0Ur9mQ" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>
    <p>Boosterpos selain develope boosterpos solutions app juga menyediakan berbagai aplikasi kasir untuk kebutuhan bidang usaha, daftar list <a title="aplikasi toko" href="/toko">aplikasi toko</a>.</p>
    <hr/><p>Boosterpos Retail</p>
    <img alt="aplikasi kasir online" class="img-fluid rounded shadow" src="./img/aplikasikasironline.png"/>
<p>Simple aplikasi toko kasir dengan kelebihan pencatatan credit pelanggan memudahkan dalam kebutuhan pembukuan dan transaksi.</p>
<Link class="button" to="/retail">More info</Link>
</div>
<div class="col-12 col-md-6 p-3 p-md-5 bg-white text-left">
<p>Chrompos</p>
<img alt="aplikasi toko kasir" class="img-fluid rounded shadow" src="./img/softwarekasir-penjualan-pos.png"/>
<p>Inilah aplikasi toko , aplikasi kasir terlengkap dan terbaik rekomendasi untuk digunakan pada usaha dengan kebutuhan kompleks dengan touchscreen modern desain.</p>
<a class="button" href="./img/CHROMPOS retail.pdf">Download</a> <a class="button" href="https://www.youtube.com/playlist?list=PLQDm6k9_HvYN3UhrrV1LqEJRFdO7H-NZn" target="blank">Video</a>
</div>
<div class="col-12 col-md-6 p-3 p-md-5 bg-white text-left">
<p>Online POS</p>
<img alt="aplikasi toko online" class="img-fluid rounded shadow" src="./img/wepos updates.png"/>
<p>Online integrasi antara aplikasi toko kasir online dengan toko online shop memudahkan mu dalam inventori management cek omset profit dengan integrasi system nya.</p>
<a class="button" href="./img/Integrated pos.pdf">Download</a> <a class="button" href="https://www.youtube.com/watch?v=T6tdX1OzvWs" target="blank">Video</a>
</div>
<div class="col-12 col-md-6 p-3 p-md-5 bg-white text-left">
<p>Axcorapos</p>
<img alt="aplikasi toko kasir" class="img-fluid rounded shadow" src="./img/1.login-mesinkasironlien.png"/>
<p>Kompleks dan simple aplikasi kasir toko dengan expired date cocok digunakan pada toko kelontong apotik , lengkap fitur inventori stok , penjualan , dan laporan laporan details.</p>
<a class="button" href="./img/AXCORAPOS.pdf">Download</a> <a class="button" href="https://www.youtube.com/watch?v=OmC_2bswSmA" target="blank">Video</a>
</div>
<div class="col-12 col-md-6 p-3 p-md-5 bg-white text-left">
<p>Simple POS</p>
<img alt="aplikasi toko online" class="img-fluid rounded shadow" src="./img/1. login software kasir gratis program kasir online.png"/>
<p>Simple system dengan metode print out invoice A4 letter maupun struk kasir untuk kebutuhan cetak dilengkapi dengan laporan dan fitur detail lengkap dalam digunakan.</p>
<a class="button" href="./img/hockeysimple pos.pdf">Download</a> <a class="button" href="https://www.youtube.com/watch?v=rNaH_gmcDDo" target="blank">Video</a>
</div>
<div class="col-12 col-md-6 p-3 p-md-5 bg-white text-left">
<p>HC POS</p>
<img alt="aplikasi toko online" class="img-fluid rounded shadow" src="./img/1. login.png"/>
<p>Inilah aplikasi toko , aplikasi kasir terlengkap dengan simple system dalam penggunaan nya era modern app untuk digunakan menunjang usaha dengan kebutuhan simplenya.</p>
<a class="button" href="./img/HOCKEY POS.pdf">Download</a> <a class="button" href="https://www.youtube.com/watch?v=tdxyKKKKCrg" target="blank">Video</a>
</div>
<div class="col-12 col-md-6 p-3 p-md-5 bg-white text-left">
<p>Light POS</p>
<img alt="aplikasi toko keren wallpaper produk" class="img-fluid rounded shadow" src="./img/8. order pos.png"/>
<p>Special untuk penjualan dengan metode wallpaper product pada pos penjualan menjadikan lebih keren untuk digunakan, dan dengan laporan detail cek profit omset penjualan.</p>
<a class="button" href="./img/LIGHT POS NEW FASHIONABLE POINT OF SALE.pdf">Download</a> <a class="button" href="https://www.youtube.com/watch?v=N-U8nYwAdUM" target="blank">Video</a>
</div>
<div class="col-12 col-md-6 p-3 p-md-5 bg-white text-left">
<p>Multi POS</p>
<img alt="aplikasi toko multi cabang" class="img-fluid rounded shadow" src="./img/aplikasitoko-multicabang.png"/>
<p>Solusi aplikasi toko untuk multi cabang toko shop store dalam satu databased memudahkan kontrol pembukuan pada setiap cabang cabang mu semakin mempermudah dalam monitoring.</p>
<a class="button" href="./img/MULTIPOS OUTLET.pdf">Download</a> <a class="button" href="https://www.youtube.com/watch?v=gxZkDnfH-Mk" target="blank">Video</a>
</div>
<div class="col-12 col-md-6 p-3 p-md-5 bg-white text-left">
<p>IPOS</p>
<img alt="aplikasi toko ipos invoice pos" class="img-fluid rounded shadow" src="./img/ipos.png"/>
<p>Invoice point of sale , techno point of sale dengan metode invoice lengkap dengan pembayaran tempo dan cicilan pelanggan dengan simple system dan support kasa area.</p>
<a class="button" href="./img/Invoice point of sale app.pdf">Download</a> <a class="button" href="https://www.youtube.com/playlist?list=PLQDm6k9_HvYPbuAl0m6Fn_DUdMe-sr3EM" target="blank">Video</a>
</div>
<div class="col-12 p-3 md-5 text-center">
<p>Itu lah daftar <a href="/toko" title="aplikasi toko online">aplikasi toko online</a> dan offline untuk digunakan pada berbagai bidang usaha , back to <Link to="/">Home Page</Link></p>
</div>
</div>
  </Layout>
)

export default TokoPage
